import request from './request'

/**
 * 获取分销图片
 * @param courseId 课程ID
 * @param courseUrl 课程URL
 * @returns {AxiosPromise<any>}
 */
export function getFenxiaoImg(courseId, courseUrl) {
  const url = '/course/shareCourse'
  return request.get(url, {
    params: {
      url: courseUrl,
      course_id: courseId
    }
  })
}



// WEBPACK FOOTER //
// ./src/api/fenxiao.js